import React from "react";
import PolicyPage from "@/pages/PolicyPage";

export default function PaymentPolicy() {
  return (
    <PolicyPage
      title="Payment Policy"
      sections={[
        {
          paragraphs: ["Payment is arranged after appointment confirmation."],
        },
        {
          heading: "Pricing Factors",
          paragraphs: ["Pricing may vary depending on:"],
          bullets: [
            "travel distance",
            "urgency",
            "scheduling requirements",
            "same-day/rush requests",
            "service complexity",
            "provider/facility arrangements",
          ],
        },
        {
          heading: "Secure Payment Process",
          paragraphs: [
            "Secure payment links and invoices are sent directly to approved clients after review and confirmation.",
          ],
        },
        {
          heading: "Deposits & Advance Payment",
          paragraphs: [
            "T&J Clinical Solutions reserves the right to request deposits or advance payment for certain appointments or custom service arrangements.",
          ],
        },
        {
          heading: "Late or Missed Payment",
          paragraphs: [
            "Failure to complete payment within the requested timeframe may result in cancellation or delay of services.",
          ],
        },
      ]}
    />
  );
}
